import { render, staticRenderFns } from "./ProductionCalendar.vue?vue&type=template&id=a35c0bb2&"
import script from "./ProductionCalendar.vue?vue&type=script&lang=js&"
export * from "./ProductionCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports